import { StudioState } from "@odingard/design-system";
import type { ReviewInteractionState } from "./interactionStates";

interface Props {
  state: ReviewInteractionState;
  retry?: () => void;
  alternativeActor?: string;
  permission?: string;
}

export function InteractionStatePresenter({ state, retry, alternativeActor, permission }: Props) {
  if (state === "unauthorized") {
    return (
      <StudioState
        state={state}
        description={`You do not hold ${permission ?? "the permission required"} for this action; ask an organization administrator for access.`}
      />
    );
  }
  if (state === "unentitled") return <StudioState state={state} product="Review AI" />;
  if (state === "dependency_unavailable") {
    return (
      <StudioState
        state={state}
        {...(retry ? { onRetry: retry } : {})}
      />
    );
  }
  if (state === "concurrent_state_conflict") {
    return (
      <StudioState
        state={state}
        {...(retry ? { onRetry: retry } : {})}
      />
    );
  }
  if (state === "refused_for_separation_of_duties") {
    const actor = alternativeActor ?? "the accountable owner or assigned reviewer";
    return (
      <StudioState
        state={state}
        description={`This action must be taken by ${actor}; changing your permissions would not change this record restriction.`}
      />
    );
  }
  return (
    <StudioState
      state="error"
      title="Review AI action unavailable"
      description="Review AI could not complete this request. Try again later."
      {...(retry ? { onRetry: retry } : {})}
    />
  );
}
